import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class UISettingsService {
  constructor(private http: HttpClient) {}

  public fetchUISettings(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_UI`
    return this.http.get(url, {})
  }

  public updateUISettings(payload: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_UI`
    return this.http.put(url, payload)
  }
}
